const Loader = () => {
    return(
        <>
        <div style={{textAlign: 'center'}}>
            <div className="loader"></div>
        </div>
        </>
    )
}

export default Loader;